/**
 * Shop by Goal / Shop by Category → collection facet filters
 * Scrolls to filters, applies the matching facet, and persists in sessionStorage.
 */
(function () {
  var SCROLL_TARGET = '#collection-filters';
  var CLEARED_FLAG = 'griffys_filters_cleared';

  var FILTER_CONFIG = {
    goal: {
      param: 'filter.p.m.custom.goal',
      storage: 'griffys_goal_filter',
      cardSelector: '[data-goal-filter-grid] .goal-card[data-goal-filter]',
      dataAttr: 'data-goal-filter'
    },
    category: {
      param: 'filter.p.m.custom.category',
      storage: 'griffys_category_filter',
      cardSelector: '[data-category-filter-grid] .cat-tile[data-category-filter]',
      dataAttr: 'data-category-filter'
    }
  };

  function getParams(search) {
    return new URLSearchParams(typeof search === 'string' ? search : window.location.search);
  }

  function syncSessionFromParams(searchParams) {
    var params =
      searchParams instanceof URLSearchParams
        ? searchParams
        : getParams(searchParams || '');

    var hasDiscoveryFilter = false;
    Object.keys(FILTER_CONFIG).forEach(function (key) {
      var cfg = FILTER_CONFIG[key];
      var values = params.getAll(cfg.param);
      if (values.length) {
        hasDiscoveryFilter = true;
        sessionStorage.setItem(cfg.storage, values[values.length - 1]);
      } else {
        sessionStorage.removeItem(cfg.storage);
      }
    });

    if (hasDiscoveryFilter) {
      sessionStorage.removeItem(CLEARED_FLAG);
    }
  }

  function clearDiscoverySessions() {
    Object.keys(FILTER_CONFIG).forEach(function (key) {
      sessionStorage.removeItem(FILTER_CONFIG[key].storage);
    });
    sessionStorage.setItem(CLEARED_FLAG, '1');
  }

  // Expose for facet clear handlers
  window.GriffysDiscoveryFilters = {
    syncSessionFromParams: syncSessionFromParams,
    clearDiscoverySessions: clearDiscoverySessions
  };

  function scrollToFilters() {
    var target =
      document.querySelector(SCROLL_TARGET) || document.getElementById('CollectionProductGrid');
    if (!target) return;
    var header = document.querySelector(
      '.header, #header, [data-header], .shopify-section-header'
    );
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function isFilterAlreadyActive(param, value) {
    var current = getParams().getAll(param);
    return current.length === 1 && current[0] === value;
  }

  function applyFilter(param, storageKey, value, options) {
    options = options || {};
    if (!value) return;

    sessionStorage.removeItem(CLEARED_FLAG);
    sessionStorage.setItem(storageKey, value);

    if (isFilterAlreadyActive(param, value)) {
      if (options.scroll !== false) scrollToFilters();
      return;
    }

    var params = getParams();
    params.delete(param);
    params.append(param, value);
    var searchParams = params.toString();

    if (options.hardNavigate) {
      window.location.replace(
        window.location.pathname +
          (searchParams ? '?' + searchParams : '') +
          (options.scroll !== false ? SCROLL_TARGET : '')
      );
      return;
    }

    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(searchParams);
      if (options.scroll !== false) setTimeout(scrollToFilters, 150);
      return;
    }

    window.location.assign(
      window.location.pathname + (searchParams ? '?' + searchParams : '') + SCROLL_TARGET
    );
  }

  function patchFacetSessionSync() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.__discoverySessionPatched) {
      return;
    }
    var originalUpdateURLHash = FacetFiltersForm.updateURLHash;
    FacetFiltersForm.updateURLHash = function (searchParams) {
      originalUpdateURLHash.call(this, searchParams);
      syncSessionFromParams(searchParams);
    };
    FacetFiltersForm.__discoverySessionPatched = true;
  }

  function bindCards() {
    Object.keys(FILTER_CONFIG).forEach(function (key) {
      var cfg = FILTER_CONFIG[key];
      document.querySelectorAll(cfg.cardSelector).forEach(function (card) {
        if (card.__discoveryBound) return;
        card.__discoveryBound = true;
        card.addEventListener('click', function (event) {
          var value = card.getAttribute(cfg.dataAttr);
          if (!value) return;

          var href = card.getAttribute('href') || '';
          var isFilterAction =
            href === '' ||
            href === '#' ||
            href === SCROLL_TARGET ||
            href.indexOf(SCROLL_TARGET) === 0;
          if (!isFilterAction) return;

          if (
            !document.getElementById('FacetFiltersForm') &&
            !document.getElementById('FacetFiltersFormMobile')
          ) {
            return;
          }

          event.preventDefault();
          applyFilter(cfg.param, cfg.storage, value, { scroll: true });
        });
      });
    });
  }

  function bindClearAllLinks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest(
        'a.js-facet-clear-all, a.js-facet-remove, .no-content-message a'
      );
      if (!link) return;

      var text = (link.textContent || '').replace(/\s+/g, ' ').trim();
      var isClearAll =
        link.classList.contains('js-facet-clear-all') ||
        /clear\s*all/i.test(text) ||
        link.getAttribute('href') === window.location.pathname ||
        link.getAttribute('href') === window.location.pathname + '/';

      if (!isClearAll) return;

      // Always wipe persisted Goal/Category so they cannot be restored after clear
      clearDiscoverySessions();
    }, true);
  }

  function restoreFromSession() {
    // User explicitly cleared filters — do not re-apply
    if (sessionStorage.getItem(CLEARED_FLAG) === '1') {
      Object.keys(FILTER_CONFIG).forEach(function (key) {
        sessionStorage.removeItem(FILTER_CONFIG[key].storage);
      });
      return;
    }

    var params = getParams();
    var needsRedirect = false;
    var nextParams = getParams();

    Object.keys(FILTER_CONFIG).forEach(function (key) {
      var cfg = FILTER_CONFIG[key];
      var urlValues = params.getAll(cfg.param);

      if (urlValues.length) {
        sessionStorage.setItem(cfg.storage, urlValues[urlValues.length - 1]);
        return;
      }

      var saved = sessionStorage.getItem(cfg.storage);
      if (!saved) return;

      nextParams.delete(cfg.param);
      nextParams.append(cfg.param, saved);
      needsRedirect = true;
    });

    if (window.location.hash === SCROLL_TARGET) {
      setTimeout(scrollToFilters, 100);
    }

    if (!needsRedirect) return;

    window.location.replace(
      window.location.pathname + '?' + nextParams.toString()
    );
  }

  function init() {
    patchFacetSessionSync();
    bindCards();
    bindClearAllLinks();
    restoreFromSession();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof FacetFiltersForm !== 'undefined') {
        init();
      } else {
        window.addEventListener('load', init);
      }
    });
  } else if (typeof FacetFiltersForm !== 'undefined') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
